import { useEffect, useState } from "react"
import sharedService from "../../../Services/SharedService"
import { BOXGROUP_ID, groupBR } from "../../../Utils/const"


const ParamsComponent = () => {
    const [group, setGroup] = useState({})

    useEffect(() => {
        getGroup()
    }, [])

    function getGroup() {
        sharedService.getBoxGroup(BOXGROUP_ID).then(res => {
            const data = res.data
            setGroup({ ...data })
        }).catch(e => console.log(e))
    }

    return <div className="ParamsComponent">
        <table>
            <thead>
                <tr>
                    <th className="center">TT</th>
                    <th className="center">Thông số kỹ thuật</th>
                    <th className="center">Đơn vị tính</th>
                    <th className="center">{groupBR.find(g => g.id === BOXGROUP_ID)?.name}</th>
                </tr>
            </thead>
            <tbody>
                {group.params?.length > 0 && group.params.map((p, i) =>
                    <tr key={i}>
                        <td className="center">{p?.[0]}</td>
                        <td>{p?.[1]}</td>
                        <td className="center">{p?.[2]}</td>
                        <td className="center">{p?.[3]}</td>
                    </tr>
                )}

            </tbody>
        </table>
    </div>
}

export default ParamsComponent